import { useContext } from "react";
import BadgeUnidade from "../../../../../../shared/components/badgeUnidade/BadgeUnidade";
import { AuthContext } from "../../../../../../shared/context/auth-context";
import { dadosImpressao } from "../../../../../../shared/util/dadosImpressao";
import "../List.scss";

//mui
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Tooltip from "@mui/material/Tooltip";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined"; //gerar Pdf

import { Trash2, Check } from "lucide-react";

//Antd
import { Popover } from "antd";
import { Popconfirm } from "antd";

import { abreviarNome } from "../../../../../../shared/util/helperFunctions";

function ListRequisicaoExames(props) {
  const auth = useContext(AuthContext);

  const verRequisicao = (id) => {
    /* Compara por `_id`, não por `id`.
       Este endpoint devolve documentos do mongoose, e o `res.json` não inclui
       o virtual `id` — só as consultas `.lean()` é que o trazem. Com `id`
       indefinido dos dois lados, o filtro dava verdadeiro para TODAS as linhas
       e imprimia-se sempre a primeira, clicasse-se na que se clicasse. Numa
       clínica com duas unidades isso aparecia como um documento da Praia a sair
       com a morada de Assomada. */
    const filteredRequisicao = props.data.filter((impr) => {
      return impr._id === id;
    });

    props.requisicaoData(
      filteredRequisicao[0].cliente,
      // A morada impressa é a da unidade onde o documento foi emitido, não a de
      // quem o está a reimprimir.
      dadosImpressao(
        filteredRequisicao[0].clinica,
        filteredRequisicao[0].estabelecimento,
      ),
      filteredRequisicao[0].medico_responsavel,
      filteredRequisicao[0].dataRequisicao,
      filteredRequisicao[0].examesSangue,
      filteredRequisicao[0].examesUrina,
      filteredRequisicao[0].fezes,
      filteredRequisicao[0].fezesNota,
      filteredRequisicao[0].naturalidade,
      filteredRequisicao[0].procedencia,
      filteredRequisicao[0].diagnostico
    );
  };

  let content = [];
  if (props.data) {
    props.data.forEach((row) => {
      content.push(
        <div className="dots__menu__popup">
          {auth.perm.includes("d-impr") &&
            row.medico_responsavel._id === auth.userId && (
              <Popconfirm
                title="Desativar requisição"
                description="Tem a certeza que pretende desativar a requisição?"
                icon={<Trash2 style={{ color: "red" }} />}
                okText="Sim"
                cancelText="Não"
                onConfirm={props.handleDesativar.bind(null, row._id)}
              >
                <div className="popOverMenu--option">
                  <span>Desativar</span>
                  <Trash2 className="popOverMenu--option__icon" />
                </div>
              </Popconfirm>
            )}
        </div>
      );
    });
  }

  return (
    <>
      <TableContainer component={Paper} className="table">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead style={{ background: "#fff" }}>
            <TableRow>
              <TableCell className="tableCell tableCell--heading">
                Médico Responsável
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Data Requisição
              </TableCell>

              <TableCell className="tableCell tableCell--heading">
                Ações
              </TableCell>
            </TableRow>
          </TableHead>

          {props.data && (
            <TableBody>
              {props.data.map((row, index) => (
                <TableRow key={row._id}>
                  <TableCell className="tableCell">
                    {abreviarNome(row.medico_responsavel.name)}
                    <BadgeUnidade estabelecimento={row.estabelecimento} />
                  </TableCell>
                  <TableCell className="tableCell">
                    {row.data_requisicao}
                  </TableCell>
                  <TableCell className="tableCell">
                    <div className="botoes-action">
                      <div
                        style={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        {auth.perm.includes("r-impr") && (
                          <Tooltip title="Gerar Pdf">
                            <PictureAsPdfOutlinedIcon
                              className="action-button-with-tooltip"
                              onClick={verRequisicao.bind(null, row._id)}
                              style={{ cursor: "pointer" }}
                            />
                          </Tooltip>
                        )}

                        {/* {(auth.role === "Médico/Administrador" ||
                          auth.role === "Dentista") &&
                          row.medico_responsavel._id === auth.userId && (
                            <Tooltip title="Marcar Efetuado">
                              <Check
                                className="icon__list"
                                onClick={props.marcarEfetuado.bind(
                                  null,
                                  row.id
                                )}
                              />
                            </Tooltip>
                          )} */}
                      </div>

                      {content[index] && (
                        <Popover
                          content={content[index]}
                          trigger="click"
                          placement="bottom"
                        >
                          <div className="dots__menu">
                            <div className="dot"></div>
                            <div className="dot"></div>
                            <div className="dot"></div>
                          </div>
                        </Popover>
                      )}
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
      </TableContainer>
    </>
  );
}

export default ListRequisicaoExames;
